import React, { useState, useContext } from 'react';
import { NotebookContext } from '../../../context/NotebookContext';
import { UserContext } from '../../../context/UserContext';
import client from '../../../lib/client';
import { editAccountMutation } from '../../../queries/account';
import { editNotebookMutation } from '../../../queries/notebooks';
import {
  EditAccountMutation,
  EditAccountMutationVariables
} from '../../../queries/__generated__/EditAccountMutation';
import { Input } from '../../forms';
import { Button, Card, CardSegment } from '../../ui';
import { toast } from 'react-toastify';

interface AccountNameProps {
  account: {
    id: string;
    name: string;
    owner: {
      id: string;
    };
  };
}

const AccountName: React.FC<AccountNameProps> = ({ account }) => {
  const { user } = useContext(UserContext);
  const { notebook, reloadNotebook } = useContext(NotebookContext);
  const [spaceName, setSpaceName] = useState(notebook.name);

  const isAccountOwner = user.id === account.owner.id;

  async function saveAccount() {
    /**
     * Here we're keeping the name of the account and the notebook in sync.
     */
    if (spaceName) {
      await client.mutate<EditAccountMutation, EditAccountMutationVariables>({
        mutation: editAccountMutation,
        variables: {
          input: {
            id: account.id,
            name: spaceName
          }
        }
      });

      await client.mutate({
        mutation: editNotebookMutation,
        variables: {
          input: {
            notebookId: notebook.id,
            name: spaceName
          }
        }
      });

      toast('Space settings updated!', { type: 'success' });
    }
  }

  return (
    <Card className="mb2">
      <CardSegment className="pa4">
        <Input
          label="name"
          className="mb3"
          value={spaceName}
          onChange={e => setSpaceName(e.target.value)}
          placeholder="Enter a group name..."
          disabled={!isAccountOwner}
          data-testid="account-name-input"
        />

        {isAccountOwner && (
          <Button onClick={saveAccount} data-testid="account-name-save-button">
            Save
          </Button>
        )}
      </CardSegment>
    </Card>
  );
};

export default AccountName;
